import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { useTheme } from './context/ThemeContext';
import { ToastProvider } from './context/ToastContext';

// Layout components
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ListsPage from './pages/ListsPage';
import ListDetailPage from './pages/ListDetailPage';
import CreateListPage from './pages/CreateListPage';
import EditListPage from './pages/EditListPage';
import ImportCsvPage from './pages/ImportCsvPage';
import QrScannerPage from './pages/QrScannerPage';
import TrainingPage from './pages/TrainingPage';
import TrainingSessionPage from './pages/TrainingSessionPage';
import StatsPage from './pages/StatsPage';
import SettingsPage from './pages/SettingsPage';
import NotFoundPage from './pages/NotFoundPage';

import './styles/App.css';

function App() {
  const { isAuthenticated, isLoading } = useAuth();
  const { theme } = useTheme();

  // Show loading while checking auth state
  if (isLoading) {
    return (
      <div className={`app-loading ${theme}`}>
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <ToastProvider>
      <div className={`app ${theme}`}>
        <Routes>
          {/* Public routes */}
          <Route
            path="/login"
            element={isAuthenticated ? <Navigate to="/lists" replace /> : <LoginPage />}
          />
          <Route
            path="/register"
            element={isAuthenticated ? <Navigate to="/lists" replace /> : <RegisterPage />}
          />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

          {/* Protected routes with layout */}
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/" element={<Navigate to="/lists" replace />} />
            <Route path="/lists" element={<ListsPage />} />
            <Route path="/lists/new" element={<CreateListPage />} />
            <Route path="/lists/:id" element={<ListDetailPage />} />
            <Route path="/lists/:id/edit" element={<EditListPage />} />
            <Route path="/import/csv" element={<ImportCsvPage />} />
            <Route path="/import/qr" element={<QrScannerPage />} />
            <Route path="/training" element={<TrainingPage />} />
            <Route path="/training/:listId" element={<TrainingSessionPage />} />
            <Route path="/stats" element={<StatsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>

          {/* 404 Not Found */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </ToastProvider>
  );
}

export default App;
